module.exports = __webpack_public_path__ + "static/shadow_mastiff-fababb148a31c653ec3e0020f623780d.jpeg";